import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import getTileWidth from "../../../../../utils/getTileWidth/getTileWidth";
import chunkData from "../chunkData/chunkData";
import Tile from "../../../Tile/Tile";
import styles from "./BuildGrid.module.css";
import { IRecipe } from "../../Grid";
import { RootState } from "../../../../../redux/store";

interface IBuildGrid {
    items: IRecipe[];
    itemType?: string;
}

const BuildGrid: React.FC<IBuildGrid> = (props) => {
    const isMobile = useSelector((state: RootState) => state.client.isMobile);
    let tilesInRow = 6;
    if (isMobile) {
        tilesInRow = 2;
    }
    const [tileWidth, setTileWidth] = useState("0px");
    useEffect(() => {
        setTileWidth(getTileWidth(tilesInRow, isMobile));
        function handleResize() {
            setTileWidth(getTileWidth(tilesInRow, isMobile));
        }
        window.addEventListener("resize", handleResize);
    }, [props.items]);

    let chunked_list = chunkData(props.items, tilesInRow);
    let gridItems: JSX.Element[] = [];
    if (chunked_list.length > 0) {
        gridItems = chunked_list.map((row, rowIndex) => (
            <div className={styles.row} key={"row-" + rowIndex}>
                {row.map((item, colIndex) => (
                    <div className={styles.col} key={"col-" + colIndex} style={{ width: tileWidth }}>
                        {item.imageUrl != null ? (
                            <Tile
                                tileWidth={tileWidth}
                                image={item.imageUrl}
                                name={item.name}
                                isPublic={item.isPublic}
                                id={item.id}
                                isFromExplore={item.isFromExplore}
                                itemType={props.itemType}
                            />
                        ) : (
                            <p></p>
                        )}
                    </div>
                ))}
            </div>
        ));
    }
    return <div className={styles.placeholder}>{gridItems}</div>;
};

export default BuildGrid;
